// Determina si la orden de llenado debe mostrarse para una unidad.
// Tolera los dos shapes de configuración presentes en el estado, ambos
// alimentados por el mismo endpoint (/units/conf):
//   - carburations.unitConfigs  -> { id, config: { showFillingOrder } }
//   - unitsReducer.unitsConfigArr -> { id, conf:   { showFillingOrder } }
export const isFillingOrderVisible = ({ unitConfigs = [], unitId }) => {
  const unit = unitConfigs.find(u => u.id === unitId);
  const config = unit?.config ?? unit?.conf;
  return config?.showFillingOrder ?? true;
};

export const maskOrderValue = ({ unitConfigs, unitId, orderValue }) => {
  let displayedOrder = "- - - -";
  const strValue = orderValue != null ? String(orderValue) : "";
  if (strValue.length) {
    displayedOrder = isFillingOrderVisible({ unitConfigs, unitId })
      ? strValue
      : "*".repeat(strValue.length);
  }
  return displayedOrder;
};

// Enmascara el número de orden de cada elemento según la configuración de la
// unidad. Acepta directamente cualquiera de los dos shapes de unitConfigs
// (ver isFillingOrderVisible), por lo que cada consumidor pasa el slice que ya
// tiene cargado sin normalizaciones previas.
export const getMaskedOrderNumbers = ({ unitConfigs, unitId, orders }) => {
  return (orders ?? []).map(order => ({
    ...order,
    numberOrderExtra: maskOrderValue({ unitConfigs, unitId, orderValue: order?.numberOrderExtra })
  }));
};
